<script>
export default {
  props: {
    soalStats: Object,
    listItem: Object,
    currentQuestion: Object,
    is_instruksi: Number,
    mengerjakan: Function,

    currentQuestionOptionList: Object,
    currentQuestionShuffleOptionList: Object,
    answers: Array,
    currentIndex: Number,
    hasImageOptions: Boolean,
    currentPage: Number,
    selectAnswer: Function,

    openProgressFinal: Function,
    nextQuestion: Function,
    nextSoal: Function,
    last_page: Number,
    index_soal: Number,
    status_pengerjaan: Number,
  },

  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
    };
  },

  computed: {
    jawabanBenar() {
      return this.currentQuestionOptionList?.find(j => j.jawaban?.toLowerCase() === 'benar');
    },
    jawabanSalah() {
      return this.currentQuestionOptionList?.find(j => j.jawaban?.toLowerCase() !== 'benar');
    },
  },
};
</script>

<template>
  <div v-if="currentQuestion" class="mym-question-body">
    <!-- TOMBOL MULAI -->
    <div class="pt-3 mb-3">
      <div class="text-center fw-bold">
        <button
          type="button"
          class="mym-btn mym-bg-success w-100"
          @click="nextSoal(0)"
        >
          <i class="fas fa-play me-1"></i>
          MULAI MENGERJAKAN
        </button>
      </div>
    </div>

    <!-- LABEL INSTRUKSI -->
    <div class="mym-question-navigation">
      <div class="mym-qn-header">
        <div class="mym-question-number">
          <strong>Instruksi</strong>
        </div>
      </div>

      <div class="mym-question-section">
        <h4>Petunjuk Benar Salah</h4>
        <p>
          Silahkan pilih salah satu jawaban dengan klik pada pilihan jawaban
          yang tersedia.
        </p>
        <p>Klik "preview" untuk menampilkan gambar</p>

        <div class="mb-3">
          <b>Contoh Soal</b>

          <!-- Studi Kasus -->
          <div class="mym-card-case mt-2 mb-3" v-if="currentQuestion?.soal_text">
            <div class="mym-card-jumbotron-header">
              <div class="mym-card-jumbotron-icon text-light">
                <i class="fa fa-file-alt"></i>
              </div>
              <h3 class="mym-card-jumbotron-title">Studi Kasus</h3>
            </div>
            <div class="mym-card-jumbotron-content">
              {{ currentQuestion?.soal_text }}
            </div>
          </div>

          <!-- Gambar soal -->
          <img
            v-if="currentQuestion?.soal_image"
            :src="BACKEND_URL + currentQuestion?.soal_image"
            class="mym-question-image mb-3"
          />

          <!-- Pertanyaan -->
          <div class="mym-question-text">
            {{ currentQuestion?.pertanyaan }}
          </div>
        </div>
      </div>
    </div>

    <!-- OPTIONS SECTION -->
    <div class="mym-options-section">
      <div class="mym-options boolean-mode">
        <!-- BENAR - selalu kiri -->
        <div
          class="mym-option-card boolean-card"
          :class="{ active: jawabanBenar?.selected }"
          @click="jawabanBenar && selectAnswer(currentQuestion, jawabanBenar)"
        >
          <div class="boolean-content">
            <div class="boolean-icon">
              <span :class="jawabanBenar?.selected ? 'text-primary' : ''" class="icon-i">
                <i class="fa fa-check fa-fw"></i>
              </span>
            </div>
            <div class="boolean-text">Benar</div>
          </div>
        </div>

        <!-- SALAH - selalu kanan -->
        <div
          class="mym-option-card boolean-card boolean-danger"
          :class="{ 'text-danger': jawabanSalah?.selected }"
          @click="jawabanSalah && selectAnswer(currentQuestion, jawabanSalah)"
        >
          <div class="boolean-content">
            <div class="boolean-icon">
              <span :class="jawabanSalah?.selected ? 'text-danger' : ''" class="icon-i">
                <i class="fa fa-times fa-fw"></i>
              </span>
            </div>
            <div class="boolean-text">Salah</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mym-question-image-wrapper {
  display: flex;
  justify-content: center;
}

.mym-question-image {
  width: 65%;
  height: auto;
}
</style>
